<template>
  <div>
    <v-layout>
      <v-flex>
        <v-btn @click="showMessaging">Leave a Message to Author</v-btn>
        <v-dialog v-model="dialog" max-width="500px">
          <v-card>
            <v-card-title>
              Leave a Message
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model="messageToAuthor"
                hide-details
                textarea
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-btn flat @click.stop="dialog=false">Close</v-btn>
              <v-btn color="primary" flat @click.stop="submitMessage">Submit</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex>
        <v-list two-line>
          <template v-for="(item, index) in items">
            <v-subheader v-if="item.header" :key="item.header">{{ item.header }}</v-subheader>
            <v-divider v-else-if="item.divider" :inset="item.inset" :key="index"></v-divider>
            <v-list-tile avatar v-else :key="item.title">
              <v-list-tile-avatar
                color="primary primary--lighten-2"
              >
                <span class="white--text headline">{{ item.initials }}</span>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title v-html="item.title"></v-list-tile-title>
                <v-list-tile-sub-title v-html="item.subtitle"></v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>

      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        dialog: false,
        messageToAuthor: '',
        items: [
          { header: 'Comments' },
          { initials: 'A', avatar: require('@/assets/svg/Group 243.svg'), title: 'Brunch this weekend?', subtitle: "<span class='text--primary'>Ali Connors</span> &mdash; I'll be in your neighborhood doing errands this weekend. Do you want to hang out?" },
          { divider: true, inset: true },
          { initials: 'F', avatar: require('@/assets/svg/Group 243.svg'), title: 'Summer BBQ <span class="grey--text text--lighten-1">4</span>', subtitle: "<span class='text--primary'>to Alex, Scott, Jennifer</span> &mdash; Wish I could come, but I'm out of town this weekend." },
          { divider: true, inset: true },
          { initials: 'K', avatar: require('@/assets/svg/Group 243.svg'), title: 'Oui oui', subtitle: "<span class='text--primary'>Sandra Adams</span> &mdash; Do you have Paris recommendations? Have you ever been?" }
        ]
      }
    },
    methods: {
      showMessaging () {
        this.dialog = true
      },
      submitMessage () {
        alert('Message Sent!')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/module/messagingFeature.vue